const SDK_VERSION = '7.120.4';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map



// WEBPACK FOOTER //
// ./~/@sentry/core/esm/version.js